import { Directive, input } from '@angular/core';

import { TableCellAlign } from './table.model';

@Directive({
  selector: 'tr[sbTableRowClickable], tr[sb-table-row-clickable]',
  standalone: true,
  host: {
    '[class.sb-table-row-clickable]': 'true',
  },
})
export class TableRowClickableDirective {}

@Directive({
  selector: 'td[sbTableCell], td[sb-table-cell], th[sbTableCell], th[sb-table-cell]',
  standalone: true,
  host: {
    '[class.sb-table-cell]': 'true',
    '[class.sb-table-cell-center]': 'align() === "center"',
    '[class.sb-table-cell-right]': 'align() === "right"',
  },
})
export class TableCellDirective {
  align = input<TableCellAlign>();
}
